import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deallocationFailureTitle: {
    description: 'inventory.deallocationFailureTitle',
    defaultMessage: 'Failed To Deallocate',
    id: '1uNJXE',
  },
  deallocationFailureMessage: {
    description: 'inventory.deallocationFailureMessage',
    defaultMessage: 'An error occurred while attempting to deallocate',
    id: 'b46WWE',
  },
  deallocationSuccessTitle: {
    description: 'inventory.deallocationSuccessTitle',
    defaultMessage: 'Deallocation Successful',
    id: 'zi0nQ1',
  },
  deallocationSuccessMessage: {
    description: 'inventory.deallocationSuccessMessage',
    defaultMessage: 'Successfully deallocated',
    id: 'Ma0LqG',
  },
  allocationStartingTitle: {
    description: 'title of notification when allocation starts',
    defaultMessage: 'Allocation In Process',
    id: 'dUv7u8',
  },
  allocationStartingMessage: {
    description: 'message body of notification when allocation starts',
    defaultMessage: 'Allocating...',
    id: '2CP4Sy',
  },
  allocationSuccessTitle: {
    description: 'inventory.allocationSuccessTitle',
    defaultMessage: 'Allocation Successful',
    id: 'PQst68',
  },
  allocationSuccessMessage: {
    description: 'inventory.allocationSuccessMessage',
    defaultMessage: 'Successfully allocated',
    id: 'jzCh7f',
  },
  allocationPartialSuccessTitle: {
    description: 'inventory.allocationPartialSuccessTitle',
    defaultMessage: 'Allocation Completed',
    id: 'PBVfDK',
  },
  allocationPartialSuccessMessage: {
    description: 'inventory.allocationPartialSuccessMessage',
    defaultMessage: 'Allocation completed with inventory warnings',
    id: 'tbfyOB',
  },
  allocationNoItemsTitle: {
    description: 'inventory.allocationNoItemsTitle',
    defaultMessage: 'Allocation Complete',
    id: 'AvWEXZ',
  },
  allocationNoItemsMessage: {
    description: 'inventory.allocationNoItemsMessage',
    defaultMessage: 'No orders required allocation',
    id: '4WOs+J',
  },
  allocationSomeSuccessTitle: {
    description: 'inventory.allocationSomeSuccessTitle',
    defaultMessage: 'Partial Allocation Complete',
    id: 'owrgXW',
  },
  allocationSomeSuccessMessage: {
    description: 'inventory.allocationSomeSuccessMessage',
    defaultMessage: 'Some orders were allocated',
    id: 'iv3C23',
  },
  allocationPermissionsErrorTitle: {
    description: 'inventory.allocationPermissionsErrorTitle',
    defaultMessage: 'Allocation Failed',
    id: 'JE9zHW',
  },
  allocationPermissionsErrorMessage: {
    description: 'inventory.allocationPermissionsErrorMessage',
    defaultMessage: 'You do not have permission to allocate inventory',
    id: 'PPh6Vt',
  },
  allocationErrorTitle: {
    description: 'inventory.allocationErrorTitle',
    defaultMessage: 'Allocation Failed',
    id: 'ABUoSn',
  },
  allocationErrorMessage: {
    description: 'inventory.allocationErrorMessage',
    defaultMessage: 'An error occurred while attempting to allocate inventory',
    id: 'fhAAxB',
  },
  inventoryImportNotificationTitle: {
    description: 'Import Inventory Notification Title',
    defaultMessage: 'Inventory Import Complete!',
    id: 'qs8W2t',
  },
  inventoryImportNotificationContent: {
    description: 'Import Inventory Notification Message',
    defaultMessage: 'Your inventory import has completed!',
    id: 'pU7sfV',
  },
  inventoryImportFailureNotificationTitle: {
    description: 'Import Inventory Notification Title',
    defaultMessage: 'Inventory Import Failed!',
    id: 'caKA2I',
  },
  inventoryImportFailureNotificationContent: {
    description: 'Import Inventory Notification Message',
    defaultMessage: 'Your inventory import has Failed!',
    id: 'DXmVy4',
  },
  inventoryExportCompleteTitle: {
    description: 'Title for inventory export complete notification',
    defaultMessage: 'Inventory Export Ready for Download',
    id: 'GeMA1g',
  },
  inventoryExportCompleteBody: {
    description: 'Body for inventory export complete toast notification',
    defaultMessage: 'Your inventory export is ready. A download should have started automatically.',
    id: '+ZcZDQ',
  },
  inventoryExportFailureNotificationTitle: {
    description: 'Export Inventory Notification Title',
    defaultMessage: 'Inventory Export',
    id: 'N/aeS8',
  },
  inventoryExportFailureNotificationContent: {
    description: 'Export Inventory Notification Message',
    defaultMessage: 'Your inventory export has failed.',
    id: 'O2eFKD',
  },
  inventoryLocationsExportNotificationTitle: {
    description: 'Export Inventory Locations Notification Title',
    defaultMessage: 'Inventory Locations Export',
    id: 'VMKNzS',
  },
  inventoryLocationsExportNotificationContent: {
    description: 'Export Inventory Locations Notification Message',
    defaultMessage: 'Your inventory locations export is being generated',
    id: 'jKgpUU',
  },
  locationsExportCompleteTitle: {
    description: 'Title for locations export complete notification',
    defaultMessage: 'Locations Export Ready for Download',
    id: 's6i+bF',
  },
  locationsExportCompleteBody: {
    description: 'Body for locations export complete toast notification',
    defaultMessage: 'Your locations export is ready. A download should have started automatically.',
    id: '5x7yYi',
  },
  totesExportNotificationTitle: {
    description: 'Export Totes Notification Title',
    defaultMessage: 'Totes Export',
    id: 'YouqXY',
  },
  totesExportNotificationContent: {
    description: 'Export Totes Notification Message',
    defaultMessage: 'Your totes export is being generated.',
    id: 'liT5Tu',
  },
  totesExportCompleteTitle: {
    description: 'Title for totes export complete notification',
    defaultMessage: 'Totes Export Ready for Download',
    id: 'kVUPKO',
  },
  totesExportCompleteBody: {
    description: 'Body for totes export complete toast notification',
    defaultMessage: 'Your totes export is ready. A download should have started automatically.',
    id: '9Nvj6O',
  },
  totesExportNotificationErrorTitle: {
    description: 'Export Totes Error Notification Title',
    defaultMessage: 'Totes Export',
    id: 'A8YGKr',
  },
  totesExportNotificationErrorContent: {
    description: 'Export Totes Error Notification Message',
    defaultMessage: 'Your totes export has failed.',
    id: 'plS4PP',
  },
});
